import CityPageTemplate from "../city-template/CityPageTemplate";
import { castleRockConfig } from "./data";

export default function CastleRockPage() {
  return <CityPageTemplate config={castleRockConfig} />;
}